import React from "react";
import Icon from "@gc-npm/components.icon-glyph";
import CustomLink from "@gc-npm/components.custom-link";
import { COLOR_DICTIONARY } from "@gc-npm/utils.enums.colors";

const CloseButton = ({ closeFunc }) => {
  return (
    <>
      <CustomLink onClick={closeFunc} ariaLabel="Cerrar">
        <div className="close-button" aria-hidden="true">
          <Icon id="cerrar-s" width={13} color={COLOR_DICTIONARY.MOVISTAR_BLUE} />
        </div>
      </CustomLink>
      <style jsx>{`
        .close-button {
          padding: 0.4rem 0.5rem 0.3rem 0.5rem;
          border-radius: 50%;
          transform: scale(1);
          transition: transform 0.3s ease;
        }
        .close-button:hover {
          background-color: #eeeeee;
          transform: scale(1.2);
        }
      `}</style>
    </>
  );
};

export default CloseButton;
